<template>
  <div>
    <v-tooltip
      v-model="tooltipEnabled"
      :disabled="!tooltip"
      :data-tooltip-text="tooltipText"
      top
    >
      <template v-slot:activator="{ on }">
        <v-badge
          :value="badge"
          bottom
          :dot="badgeDot"
          :icon="badgeIcon"
          :color="badgeColor"
          :offset-x="badgeOffsetX"
          :offset-y="badgeOffsetY"
          :data-badge-icon="badgeIcon"
          :data-badge-color="badgeColor"
          bordered
          overlap
          avatar
        >
          <v-avatar
            v-if="name"
            :left="left"
            :rounded="rounded"
            :size="sizeList[size]"
            :color="color"
            :class="[
              transparentOutline ? 'avatarOutline' : '',
              border ? 'border border--white border--width-2' : '',
              rounded ? 'rounded-lg' : '',
              clickable ? 'pointer' : '',
              clickable ? 'avatarcontainer' : '',
            ]"
            v-on="on"
            @click="$emit('click')"
          >
            <slot>
              <div if="clickable" class="zoomicon"
                ><v-icon color="white">mdi-magnify-plus-outline</v-icon>asd</div
              >

              <v-img
                v-if="imageUrl"
                :src="imageUrl"
                :alt="name + ' profile picture'"
              />
              <span
                v-else
                :class="[
                  'white--text font-weight-regular text-uppercase',
                  size ? `${fontSizeList[size]}` : '',
                ]"
              >
                {{ initials }}
              </span>
            </slot>
          </v-avatar>
        </v-badge>
      </template>
      <slot name="tooltip">
        <span> {{ tooltipText }} </span>
      </slot>
    </v-tooltip>
  </div>
</template>

<script>
import { returnHTMLColor } from '@/utils/return-html-color'

export default {
  props: {
    size: {
      type: String,
      default: 'sm',
    },
    left: {
      type: Boolean,
      default: false,
    },
    badge: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    badgeColor: {
      type: String,
      default: 'green',
    },
    badgeIcon: {
      type: String,
      default: undefined,
    },
    badgeDot: {
      type: Boolean,
      default: false,
    },
    badgeOffsetX: {
      type: String,
      default: undefined,
    },
    badgeOffsetY: {
      type: String,
      default: undefined,
    },
    name: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      default: null,
    },
    defaultColor: {
      type: Boolean,
      default: false,
    },
    generic: {
      type: String,
      default: null,
    },
    transparentOutline: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sizeList: {
        xxs: '18',
        xs: '24',
        sm: '32',
        md: '36',
        lg: '42',
        xl: '52',
        xxl: '61',
        xxxl: '84',
        xxxxl: '100',
        xxxxxl: '150',
      },
      fontSizeList: {
        xxs: 'caption',
        xs: 'caption',
        sm: 'caption',
        md: 'caption',
        lg: 'body-2',
        xl: 'body-2',
        xxl: 'body-2',
        xxxl: 'text-h4',
        xxxxl: 'text-h4',
        xxxxxl: 'text-h3',
      },
      initials: 'OP',
      color: '#00acef',
      tooltipEnabled: false,
    }
  },
  watch: {
    user: {
      handler() {
        this.initUserObj()
      },
      deep: true,
    },
  },
  mounted() {
    this.initUserObj()
  },
  methods: {
    generateInitials() {
      let initials = this.name.match(/\b(\w)/g) || [] // James p.   => 	['J', 'p']

      initials = (
        (initials.shift() || '') + (initials.pop() || '')
      ).toUpperCase() // ['J', 'd', 'p'] => 	'JP'

      return initials
    },
    getColourFromUserName() {
      return '#' + returnHTMLColor(this.name)
    },
    initUserObj() {
      this.initials = this.generateInitials()
      this.color = this.defaultColor ? this.color : this.getColourFromUserName()
    },
  },
}
</script>

<style lang="scss" scoped>
.avatarOutline {
  /* background: rgba(255, 255, 255, 0.3); */
  -webkit-box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.34);
  -moz-box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.34);
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.34);
}
.pointer {
  cursor: pointer;
}
.zoomicon {
  display: none;
  background-color: rgba(0, 0, 0, 0.3);
  text-shadow: 0px 0px 10px #000;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  color: #fff;
  z-index: 100;
  margin: auto;
  padding: auto;
  text-align: center;
}
.avatarcontainer:hover {
  .zoomicon {
    display: block !important;
  }
}
</style>
